import React from "react";
import MuiDrawer from "@mui/material/Drawer";
import PropTypes from "prop-types";

/**
 * Drawer component wrapper for side navigation panels.
 * Wraps Material-UI Drawer with theme integration.
 * 
 * @component
 * @example
 * <Drawer anchor="left" open={open} onClose={handleClose}>
 *   <List>
 *     <ListItem button>
 *       <ListItemText primary="Home" />
 *     </ListItem>
 *   </List>
 * </Drawer>
 */
const Drawer = ({ children, ...props }) => {
  return <MuiDrawer {...props}>{children}</MuiDrawer>;
};

Drawer.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * Side from which the drawer will appear
   */
  anchor: PropTypes.oneOf(["left", "top", "right", "bottom"]),
  /**
   * The elevation of the drawer
   */
  elevation: PropTypes.number,
  /**
   * Props applied to the Modal element
   */
  ModalProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed
   */
  onClose: PropTypes.func,
  /**
   * If true, the component is shown
   */
  open: PropTypes.bool,
  /**
   * Props applied to the Paper element
   */
  PaperProps: PropTypes.object,
  /**
   * The variant to use
   */
  variant: PropTypes.oneOf(["permanent", "persistent", "temporary"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI Drawer behavior
// MUI Drawer defaults: anchor="left", variant="temporary", elevation=16

export default Drawer;

